import { axiosInstance } from "../axios";

export const thongBaoApi = {
  getAll: async () => {
    return await axiosInstance.get("/notifications");
  },
  getById: async (id) => {
    return await axiosInstance.get(`/notifications/${id}`);
  },
};
